import React from 'react';
import { Button, SvgCloseCross, SvgOkIllustration } from '@devsbb/ui';
import { useTranslation } from 'react-i18next';
import { Group } from '@/components/Group';
import { Text } from '@/components/Text';
import { ModalWindow } from '@/components/ModalWindow';
import { tk } from '@/i18n/translationKeys';

import { ModalHeader } from './styles';

interface PaymentInProgressModalProps {
  handleCloseModal: () => void;
}

export const PaymentInProgressModal = ({ handleCloseModal }: PaymentInProgressModalProps) => {
  const { t } = useTranslation();

  return (
    <ModalWindow onClose={handleCloseModal}>
      <ModalHeader data-dd-privacy="allow">
        <Button iconOnly onClick={handleCloseModal} size="M" variant="Grey" aria-label="Close">
          <SvgCloseCross />
        </Button>
      </ModalHeader>
      <div style={{ textAlign: 'center' }}>
        <Group gap={6} mobileGap={6} vertical centered>
          <SvgOkIllustration />
          <Text typography="SmallHeadline">{t(tk.yourPaymentsPaymentInProgressModalTitle)}</Text>
          <Text typography="RegularParagraph">{t(tk.yourPaymentsPaymentInProgressModalText)}</Text>
          <Button onClick={handleCloseModal} fullWidth size="L" variant="Primary">
            {t(tk.yourPaymentsBackToPaymentsButtonText)}
          </Button>
        </Group>
      </div>
    </ModalWindow>
  );
};
